import { useContext } from 'react';
import { SetPendingScrollContext } from '../context';

export function useScrollToBottomOfMessages() {
  return useContext(SetPendingScrollContext);
}